import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-admin-profile',
  templateUrl: './admin-profile.component.html',
  styleUrls: ['./admin-profile.component.scss']
})
export class AdminProfileComponent {
  @Input() form!: FormGroup;
  @Input() userProfile: any;
  @Input() years: any[] = [];
  @Input() roleList: any[] = [];
  @Input() adminSelectedRoles: any[] = [];
  @Input() adminSelectedYear: any;
  @Input() allCompanyFullName: any[] = [];
  @Input() agreeFlag = false;
  @Input() countryFlag = false;
  @Input() isTaxUpdatFlag = false;
  @Input() isTaxFormMandate = false;
  @Input() disableButton = false;

  @Output() fileChanged = new EventEmitter<any>();
  @Output() profileSubmit = new EventEmitter<boolean>();
  @Output() agreeFlagChange = new EventEmitter<boolean>();

  onRolesChange(selectedRoles: any[]) {
    this.form.patchValue({ roles: selectedRoles });
  }

  onYearChange(selectedYear: any) {
    this.form.patchValue({ ciscoSalesExperience: selectedYear.value });
  }

  onProgramAdminsChange(selected: any[]) {
    this.form.patchValue({ programAdministrators: selected });
  }

  onProgramSalesMgrsChange(selected: any[]) {
    this.form.patchValue({ programSalesManagers: selected });
  }

  onProgramSEMgrsChange(selected: any[]) {
    this.form.patchValue({ programSEManagers: selected });
  }

  openPdf() {
    window.open('https://sellerrewards-datahandler.cisco.com/shared/files/seller-rewards.pdf', '_blank');
  }

  partnerSelfService() {
    window.open('https://www.cisco.com/go/pss', '_blank');
  }
}
